import { createImageUrlBuilder } from '@sanity/image-url'
import type {
  ImageUrlBuilder,
  SanityClientLike,
  SanityImageSource,
  SanityModernClientLike,
  SanityProjectDetails,
} from '@sanity/image-url'

/**
 * Sanity configuration for building image URLs
 */
const DEFAULT_SANITY_CONFIG = {
  projectId: 'p4gom3ch',
  dataset: 'production',
  useCdn: true,
}

export const sanityImageUrlBuilder = (
  source: SanityImageSource,
  config: SanityClientLike | SanityProjectDetails | SanityModernClientLike = DEFAULT_SANITY_CONFIG
) => {
  const builder: ImageUrlBuilder = createImageUrlBuilder(config)

  return builder.image(source)
}
